// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// ##### 25-02-15 Komarov
import {
  // ##### 2025-09-11 Komarov
  getHotelContent,
  getHotelRates2,
  getHotelsAvail,
  getHotelSearch,
  getPickedCurrencyResponse,
  // ##### Komarov 2025-07-18
  setCounterAdults,
  setCounterChild,
  setCounterRooms
} from '../../../../Redux/actions';
// ##### 25-05-21 Komarov
import LoadingMessage from '../../../Library/PageDevices/LoadingMessage';
// ##### 25-05-21 Komarov
import HotelDetailsContent from './HotelDetailsContent';
// ##### 25-04-30 Komarov
import useValidateQuery from '../../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const HotelDetails = () => {
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // ##### Komarov 2025-08-05
  const Availability = useSelector(state => state.pagesRedux[state.language]?.Availability || '');

  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);
  const location = useLocation();
  // ##### Komarov 2025-07-21
  const search_data = useValidateQuery();
  useEffect(() => {
    dispatch(setCounterAdults(parseInt(search_data?.adults)));
    dispatch(setCounterChild(parseInt(search_data?.children)));
    dispatch(setCounterRooms(parseInt(search_data?.rooms)));
  }, []);

  const dispatch = useDispatch();

  dispatch(getPickedCurrencyResponse(search_data?.selected_currency));

  // ##### 24-09-16 Komarov
  const { user: currentUser } = useSelector(state => state.auth);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 23-04-12 Komarov
    const rememberLink = to => {
      // ##### 24-06-27 Komarov
      localStorage.setItem('urlToBackToRooms', to);
    };
    // ##### 24-02-22 Komarov
    const strToRemove = `/${locale}`;
    rememberLink(
      location.pathname.substring(
        location.pathname.indexOf(strToRemove) + strToRemove.length
      ) + location.search
    );
    // ##### 23-04-12 Komarov
  }, [locale, dispatch, location.pathname, location.search]);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(getHotelSearch(search_data));
    // ##### 23-04-12 Komarov
  }, [search_data, dispatch]);

  // ##### 25-02-15 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);
  const promocode = useSelector(state => state.promocode.promocode);
  // ##### Komarov 2025-09-11
  const sale = useSelector(state => state.company.sale_id);
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);
  const deviceType = useSelector(state => state.deviceType);

  // ##### 25-02-18 Komarov
  const hotels_avail_loaded = useSelector(
    state => state.hotels.hotels_avail_loaded
  );

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### Komarov 2025-05-26
    if (!hotels_avail_loaded)
      dispatch(
        getHotelsAvail({
          // ##### Komarov 2025-05-26
          sale_id: sale || null,
          promocode,
          deviceType,
          company_cipher: company_cipher || '',
          start: search_data?.start, // date of arrival
          end: search_data?.end, // date of departure
          city_id: search_data?.city_id,
          // ##### 25-05-27 Komarov
          id: search_data?.id,
          adults: search_data?.adults,
          children: search_data?.children,
          // ##### 25-03-11 Komarov
          // lower_cost_limit: 0.0, // lower cost limit of room in USD, NOT OBLIGATORY
          // upper_cost_limit: 200.0, // upper cost limit of room in USD, NOT OBLIGATORY
          quantity: search_data?.rooms, // Quantity of rooms, 1 by default, NOT OBLIGATORY
          user_id: currentUser.user_id,
          refpartner: company_id,
          language: locale,
        })
      );
  }, [
    currentUser.user_id,
    search_data?.refpartner,
    search_data?.start,
    search_data?.end,
    search_data?.city_id,
    // ##### 25-04-21 Komarov
    search_data?.id,
    search_data?.rooms,
    search_data?.adults,
    search_data?.children,
    sale,
    company_cipher,
  ]);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(
      getHotelContent({
        // ##### Komarov 2025-09-10
        id: search_data?.id,
        city_id: search_data?.city_id,
        language: locale,
        user_id: currentUser.user_id,
        refpartner: company_id,
        sale,
        promocode,
        deviceType,
        company_cipher,
        content_size: 1,
      })
    );
  }, [
    currentUser.user_id,
    search_data?.refpartner,
    search_data?.city_id,
    // ##### 25-04-21 Komarov
    search_data?.id,
    sale,
    deviceType,
    company_cipher,
    // ##### 25-03-26 Komarov
    locale,
  ]);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(
      getHotelRates2({
        search_data,
        // ##### Komarov 2025-05-26
        sale: sale || null,
        userId: currentUser.user_id,
        promocode,
        deviceType,
        company_cipher: company_cipher || '',
        refpartner: company_id,
        locale,
      })
    );
  }, [
    currentUser.user_id,
    search_data?.refpartner,
    search_data?.city_id,
    search_data.start,
    search_data?.end,
    // ##### 25-02-25 Komarov
    search_data?.hotel_id,
    sale,
    deviceType,
    company_cipher,
    search_data?.adults,
    search_data?.children,
    search_data?.rooms,
  ]);

  // ##### 25-02-12 Komarov
  const cityName = search_data?.cityName;
  const hotelName = decodeURIComponent(search_data?.hotel_name);
  const hotelcontent_loaded = useSelector(
    state => state.hotelcontent.hotelcontent_loaded
  );

  // ##### 25-02-15 Komarov
  if (!hotelcontent_loaded || !hotels_avail_loaded) {
    return <LoadingMessage />;
  }

  // ##### 25-02-15 Komarov
  return (
    <div className="HotelDetailsWrapper" data-component="HotelDetails">
      <HotelDetailsContent
        hotelName={hotelName}
        cityName={cityName}
        searchData={search_data}
        availability={Availability}
      />
    </div>
  );
};

export default HotelDetails;
